import React, {Component} from 'react'
import classNames from 'classnames';
import parse from 'html-react-parser';
import Modal from './Modal'
import AutoNotifications from './AutoNotifications'
import FocusTrap from 'focus-trap-react'
import {getNotifications} from "../../services/vu";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openModal: false,
      dropdownOpen: false,
      safariTimeoutHack: false,
      badge: 0,
      notifications: [],
      notification : {
        "id": "",
        "originId": "",
        "type": "",
        "courseCode": "",
        "academicYear": "",
        "priority": "",
        "status": "",
        "message": {
          "title": "",
          "body": ""
        },
        "action": [
          {
            "label": "",
            "url": ""
          },
          {
            "label": "",
            "url": ""
          }
        ],
        "teachingPeriodCalculator": {
          "instanceSequenceNumber": "",
          "type": ""
        }
      },
    }
  }

  componentDidMount() {
    getNotifications().then(notifications => {
      this.setState({
        badge: notifications.filter(notification => {
          return notification.status === 'Presented' || notification.status === 'Sent'
        }).length,
        notifications: notifications
      })
    })

    // let notifications = [
    //   {
    //     "id": "123",
    //     "originId": "VUConnect",
    //     "type": "HE Domestic Fees & TFN",
    //     "courseCode": "BBI61",
    //     "academicYear": "2018",
    //     "priority": "1",
    //     "status": "Presented",
    //     "message": {
    //       "title": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only).",
    //       "body": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only) ordered by proximity to Census Date."
    //     },
    //     "action": [
    //       {
    //         "label": "Action Label 1",
    //         "url": "https://vu-pmo.atlassian.net/browse/DSE-725"
    //       },
    //     ]
    //   },
    //   {
    //     "id": "123",
    //     "originId": "VUConnect",
    //     "type": "HE Domestic Fees & TFN",
    //     "courseCode": "BBI61",
    //     "academicYear": "2018",
    //     "priority": "1",
    //     "status": "Presented",
    //     "message": {
    //       "title": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only).",
    //       "body": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only) ordered by proximity to Census Date."
    //     },
    //     "action": [
    //       {
    //         "label": "Action Label 1",
    //         "url": "https://vu-pmo.atlassian.net/browse/DSE-725"
    //       },
    //       {
    //         "url": "https://vu-pmo.atlassian.net/browse/DSE-937"
    //       }
    //     ],
    //     "teachingPeriodCalculator": {
    //       "instanceSequenceNumber": "123",
    //       "type": "CTYpe"
    //     }
    //   },
    //   {
    //     "id": "456",
    //     "originId": "VUConnect",
    //     "type": "HE Domestic Fees & TFN",
    //     "courseCode": "BBI61",
    //     "academicYear": "2018",
    //     "priority": "1",
    //     "status": "Read",
    //     "message": {
    //       "title": "Fee Notifications for Defer Ineligible students (DOM only).",
    //       "body": "Fee Notifications for Defer Ineligible students (DOM only) ordered by proximity to Payment Due Date"
    //     },
    //     "action": [
    //       {
    //         "label": "Action Label 1",
    //         "url": "https://vu-pmo.atlassian.net/browse/DSE-725"
    //       },
    //       {
    //         "label": "Action Labe 2",
    //         "url": "https://vu-pmo.atlassian.net/browse/DSE-937"
    //       }
    //     ],
    //     "teachingPeriodCalculator": {
    //       "instanceSequenceNumber": "123",
    //       "type": "CTYpe"
    //     }
    //   }
    // ];

    // this.setState({
    //   badge: notifications.filter(notification => {
    //     return notification.status === 'Presented' || notification.status === 'Sent'
    //   }).length,
    //   notifications: notifications
    // })
  }

  handleDropdownToggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      safariTimeoutHack: false,
    }, () => {
      if (!this.state.dropdownOpen) {
        this.notificationButton.focus()
      } else {
        // This addresses a problem with Safari where the hidden elements in the notification dropdown seem to be made
        // focusable at a later time than in Chrome. This causes the focus-trap-react extension to throw an error.
        //   
        // Essentially we have now a hidden input field that is always focusable.
        setTimeout(() => {
          this.setState({
            safariTimeoutHack: true,
          }, () => {
            if (this.notification && this.notification[0]) {
              this.notification[0].focus()
            }
          })
        }, 1)
      }
    })
  }

  handleCloseDropdown = () => {
    this.setState({
      dropdownOpen: false,
      safariTimeoutHack: false,
    }, () => {
      if (!this.state.dropdownOpen && !this.state.openModal) {
        this.notificationButton.focus()
      }
    })
  }

  handleOpenModal = (notification) => {
    return () => {
      this.setState({
        openModal: true,
        dropdownOpen: false,
        notification: notification
      })
      AutoNotifications.updateNotificationsStatus([notification], 'Read')
    }
  }

  handleCloseModal = () => {
    this.setState({
      openModal: false
    }, () => {
      this.notificationButton.focus()
    })
  }

  navigateMenuItems = index => {
    return event => {
      const notificationIndices = Object.keys(this.notification)
      const key = event.key
      switch (key) {
        case 'ArrowDown':
          event.preventDefault()
          if (index + 1 < notificationIndices.length) {
            this.notification[index + 1].focus()
          } else {
            this.notification[0].focus()
          }
          break
        case 'ArrowUp':
          event.preventDefault()
          if (index === 0) {
            this.notification[notificationIndices.length - 1].focus()
          } else {
            this.notification[index - 1].focus()
          }
          break
      }
    }
  }

  renderFocusTrap = () => {
    let trap = this.state.dropdownOpen && this.state.safariTimeoutHack && (
      <FocusTrap
          focusTrapOptions={{
            onDeactivate: this.handleCloseDropdown,
            clickOutsideDeactivates: true,
          }}
        >
          <div className="notification-dropdown__content">
            <div className="notification-dropdown__title">Notifications</div>
            {this.state.notifications.length > 0 ? (
              <ul className="notification-dropdown__list">
                {this.state.notifications.map((notification, index) => (
                  <li
                    className={classNames(
                      'notification-dropdown__list-item',
                      {'notification-dropdown__list-item_read': notification.status === 'Read'},
                    )}
                    key={index}
                  >
                    <button
                      onClick={this.handleOpenModal(notification)}
                      onKeyDown={this.navigateMenuItems(index)}
                      tabIndex={this.state.dropdownOpen ? 0 : -1}
                      ref={ref => {
                        if (this.notification) {
                          this.notification[index] = ref
                        } else {
                          this.notification = {
                            [index]: ref
                          }
                        }
                      }}
                    >
                      <span className="list-txt">{notification.message.title}</span> {notification.priority === '1' && <span className="important-tag">Important</span>}
                    </button>
                  </li>
                ))}
              </ul>
            ) : <p tabIndex={0} className="notification-dropdown__no-content">You have no new notifications.</p>
            }
          </div>
        </FocusTrap>
    );

    return (
      <div>
        <button
          data-badge={this.state.badge}
          className={classNames(
            'header-button header-icon header-notification',
            {'badge': this.state.badge > 0},
          )}
          onClick={this.handleDropdownToggle}
          ref={ref => this.notificationButton = ref}
          tabIndex={this.state.dropdownOpen ? -1 : 0}
          aria-haspopup={true}
          aria-expanded={this.state.dropdownOpen ? 'true' : 'false'}
        >
          <span className="sr-only">Open Notifications</span>
        </button>
        {trap}
      </div>
      
    )
  }

  render() {
    return (
      <div className={classNames(
        'notification-dropdown',
        {'notification-dropdown--triangle notification-dropdown--open': this.state.dropdownOpen}
      )}>
        {this.renderFocusTrap()}

        <Modal
          className={`modal-xl modal-notification`}
          isOpen={this.state.openModal}
          handleCloseModal={this.handleCloseModal}
          title={this.state.notification.message.title}
          priority ={this.state.notification.priority}
        >
          <>
            <div className="content">
              <p>
              {parse(this.state.notification.message.body)}
              </p>
            </div>

            <div className="actionItem">
              {
                this.state.notification.action.map((action, index) => {
                  return (
                    <a key={index} className="btn btn-sm btn-tertiary btn-notification-action" href={action.url}>{action.label}</a>
                  )
                })
              }
            </div>
          </>
        </Modal>
      </div>
    )
  }
}

export default NotificationDropdown
